import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../contexts/AuthContext";
import { Logo } from "../components/Logo";

const AuthCallback = () => {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/");
      return;
    }
    const session_id = m[1];

    (async () => {
      try {
        const r = await api.post("/auth/session", { session_id });
        if (r.data?.session_token) {
          localStorage.setItem("monzal_session_token", r.data.session_token);
        }
        setUser(r.data.user);
        // Clear hash and go home
        window.history.replaceState(null, "", "/");
        navigate("/", { state: { user: r.data.user } });
      } catch (e) {
        navigate("/", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[var(--monzal-bg)]" data-testid="auth-callback-page">
      <Logo size={48} />
      <div className="mt-10 w-10 h-10 border-2 border-[var(--monzal-gold)] border-t-transparent rounded-full animate-spin" />
      <div className="overline mt-6 text-gray-400">Signing in…</div>
    </div>
  );
};

export default AuthCallback;
